/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscription_tariffwizard.js                                                                    */
/**********************************************************************************************************************/
/* Subscriptions TariffSearch */
HafasWebapp.prototype.subscriptions.TariffWizard = function (_me) {

  Hafas.ps.sub('/tariffwizard/page/browse', Hafas.bind(_me.Controller.TariffWizard.browseWizardPage, _me));

  Hafas.ps.sub('/tariffwizard/page/show', Hafas.bind(_me.Controller.TariffWizard.showWizardPage, _me));

  Hafas.ps.sub('/tariffwizard/single/select', Hafas.bind(_me.Controller.TariffWizard.setSelectedWizardElement, _me));

  Hafas.ps.sub('/tariffwizard/route/select', Hafas.bind(_me.Controller.TariffWizard.setSelectedRoute, _me));

  Hafas.ps.sub('/tariffwizard/route/addVia', Hafas.bind(_me.Controller.TariffWizard.GUI.addVia, _me));

  Hafas.ps.sub('/suggest/setLocation', Hafas.bind(function (id, loc) {
    if(!id.startsWith('TariffWizard')){
      return;
    }
    var inputId = id.split("_");
    var inputObj = {
      loc: loc,
      id: id
    };
    if (inputId[1].startsWith('Via')) {
      var viaIndex = inputId[1].substring(3, 4);
      inputObj.type = "via";
      inputObj.idx = viaIndex;
    } else {
      switch (inputId[1]) {
        case "From":
          inputObj.type = "dep";
          break;
        case "To":
          inputObj.type = "arr";
          break;
      }
    }
    Hafas.bind(_me.Controller.TariffWizard.setLocationFromSuggest, _me)(inputObj);
  }, _me));

  Hafas.ps.sub('/tariffwizard/location/clear', Hafas.bind(_me.Controller.TariffWizard.clearLocationFromData, _me));

  Hafas.ps.sub('/tariffwizard/jumpin/tp', Hafas.bind(_me.Controller.TariffWizard.jumpinFromTripPlanner, _me));
  // HDPWAPP-8254: Customer Changes
  Hafas.ps.sub('/tariffwizard/jumpout', Hafas.bind(_me.Controller.TariffWizard.jumpOut, _me));
  Hafas.ps.sub('/tariffwizard/openLibTariff', Hafas.bind(_me.Controller.TariffWizard.openLibTariffWizard, _me));
  // End customer Changes
  Hafas.ps.sub('/dateTimePicker/selectDateTime/TariffWizardDTP', Hafas.bind(_me.Controller.TariffWizard.selectDateTimeFromPicker, _me));

  // Suggest Auswahl Departure
  Hafas.ps.sub("/suggest/selectitem/TariffWizard_From", Hafas.bind(function (loc) {
    Hafas.bind(_me.Controller.TariffWizard.validateSelection, _me)("dep", "From", loc);
  }, _me));

  // Leere Datenmodell, wenn Departure-Location gelöscht wurde
  Hafas.ps.sub("/suggest/blur/TariffWizard_From", Hafas.bind(function (instance) {
    Hafas.ps.pub('/tariffwizard/location/clear', [{type: instance.config.locType}]);
  }, _me));

  // Suggest Auswahl Arrival
  Hafas.ps.sub("/suggest/selectitem/TariffWizard_To", Hafas.bind(function (loc) {
    Hafas.bind(_me.Controller.TariffWizard.validateSelection, _me)("arr", "To", loc);
  }, _me));

  // Leere Datenmodell, wenn Arrival-Location gelöscht wurde
  Hafas.ps.sub("/suggest/blur/TariffWizard_To", Hafas.bind(function (instance) {
    Hafas.ps.pub('/tariffwizard/location/clear', [{type:instance.config.locType}]);
  }, _me));

  // ClearInput des Kontext-Menüs
  Hafas.ps.sub("/tariffwizard/clearInput", Hafas.bind(_me.Controller.TariffWizard.clearInput, _me));

  // Suggest Auswahl Via
  Hafas.ps.sub("/suggest/selectitem/TariffWizard_Via0", Hafas.bind(function (loc) {
    Hafas.bind(_me.Controller.TariffWizard.validateSelection, _me)("via", "Via0", loc);
  }, _me));

  // Leere Datenmodell, wenn Arrival-Location gelöscht wurde
  Hafas.ps.sub("/suggest/blur/TariffWizard_Via0", Hafas.bind(function (instance) {
    Hafas.ps.pub('/tariffwizard/location/clear', [{type:instance.config.locType, idx: 0}]);
  }, _me));

  Hafas.ps.sub('/tariffwizard/setLocation/webapp', Hafas.bind(_me.Controller.TariffWizard.setLocation, _me));

  // Hafas.ps.sub('/tariffwizard/selectLocation', Hafas.bind(_me.Controller.TariffWizard.setLocation, _me));

  // Vorbelegung Start/Ziel
  Hafas.ps.sub('/tariffwizard/setLocationValue/webapp', Hafas.bind(_me.Controller.TariffWizard.setLocationValue, _me));

  Hafas.ps.sub('/tariffwizard/search', Hafas.bind(function (params) {
    // Search tariffs#
    var model = {
      callback: Hafas.bind(this.Controller.TariffWizard.showResultOverview, _me)
    };
    if(params.hasOwnProperty('triggerInstantSearch')) {
      model.triggerInstantSearch = params.triggerInstantSearch;
      model.value = params.value;
      model.fid = params.fid;
    }
    _me.Controller.TariffWizard.instance.searchTariffs(model);
  }, _me));

  // Ergebnisseite
  Hafas.ps.sub('/tariffwizard/resultLoaded/', Hafas.bind(_me.Controller.TariffWizard.showResultOverview, _me));
  Hafas.ps.sub('/tariffwizard/resultfail/', Hafas.bind(_me.Controller.TariffWizard.showErrorPage, _me));

  // History-Subs
  Hafas.ps.sub('/GUI/closeView/TariffWizard', Hafas.bind(_me.Controller.TariffWizard.GUI.closeView, _me));
  Hafas.ps.sub('/GUI/restoreView/TariffWizard', Hafas.bind(_me.Controller.TariffWizard.GUI.restoreView, _me));
  Hafas.ps.sub('/GUI/cleanup/TariffWizard', Hafas.bind(_me.Controller.TariffWizard.GUI.cleanup, _me));
  Hafas.ps.sub('/GUI/clearMap/TariffWizard', Hafas.bind(_me.Controller.TariffWizard.GUI.clearMap, _me));

  // TariffWizard wird verlassen
  Hafas.ps.sub('/GUI/leaveContext/TariffWizard', Hafas.bind(_me.Controller.TariffWizard.GUI.cleanup, _me));
};
